import * as Yup from 'yup';

function schema({ isCustomer = false } = {}) {
  const phoneValidation = isCustomer
    ? Yup.string()
        .required('mobile number is required')
        .test('phone-format', 'mobile number must be valid', (value) => {
          if (!value) {
            return false;
          }
          // Remove all non-digit characters to check the total length
          const digitsOnly = value.replace(/\D/g, '');
          // Should be at least 11 digits (country code + 10 digit number)
          // This accommodates different country code lengths
          return digitsOnly.length >= 11;
        })
    : Yup.string();

  return Yup.object({
    id: Yup.string().required('Required'),
    firstName: Yup.string().required('Required'),
    lastName: Yup.string(),
    phone: phoneValidation,
    language: Yup.string(),
    imageUrl: Yup.string().nullable(true),
  });
}

export default schema;
